import React, { useState } from 'react';

import { getClassNames } from '../../../../../utils/util';

import { ReactComponent as SendIcon } from '../../../../../resources/icons/send.svg';

import './support-chat-input.scss';

type Props = {
  disabled?: boolean;
  createMessage: (text: string, onSuccess: () => void) => void;
};

const SupportChatInput = ({ disabled = false, createMessage }: Props) => {
  const [message, setMessage] = useState('');

  const handleSendClick = () => {
    if (!message) {
      return;
    }

    createMessage(message, () => setMessage(''));
  };

  return (
    <div className={getClassNames('support-chat-input', { disabled })}>
      <input
        value={message}
        onChange={({ target }) => setMessage(target.value)}
        disabled={disabled}
        data-testid="chat-input"
      />
      <SendIcon onClick={handleSendClick} data-testid="send-icon" />
    </div>
  );
};

export default SupportChatInput;
